/* eslint-disable import/prefer-default-export */
import * as queryString from "query-string";
import { useState, useCallback, useMemo } from "react";

export const useCriteriaStore = (defaultCriteria = {}) => {
  const [criteria, putCriteria] = useState(defaultCriteria);
  const memoizedCriteria = useMemo(() => criteria, [criteria]);
  const getQuery = useCallback(() => queryString.stringify(memoizedCriteria), [
    memoizedCriteria,
  ]);
  const getCriteria = useCallback(() => memoizedCriteria, [memoizedCriteria]);
  const getByKey = useCallback(key => memoizedCriteria[key] || null, [
    memoizedCriteria,
  ]);
  const setCriteria = useCallback(
    newCriteria => putCriteria({ ...memoizedCriteria, ...newCriteria }),
    [memoizedCriteria, putCriteria]
  );
  const reset = useCallback(() => putCriteria(defaultCriteria), [putCriteria]);
  const clear = useCallback(() => putCriteria({}), [putCriteria]);
  return {
    criteria: memoizedCriteria,
    getQuery,
    getCriteria,
    setCriteria,
    reset,
    clear,
    getByKey,
  };
};
